<script>
    import NormalInput from './NormalInput';
    import NormalPicker from './NormalPicker';
    import moment from 'moment';

    // export component
    export default {
        name: 'normal-date-time-picker',
        props: {
            type: {type: String, default: 'date'},
            border: {type: Boolean, default: true},
            placeholder: {type: String, default: ''},
            maxYears: {type: Number, default: 2030},
            minYears: {type: Number, default: 1900},
            selected: {default: null},
            format: {type: String, default: ''},
            leftBtn: {type: String, default: '取消'},
            rightBtn: {type: String, default: '确定'},
            disabled: {type: Boolean, default: false}
        },
        model: {
            prop: 'selected',
            event: 'change'
        },
        watch: {
            selected (v) {
                this.showText = this.getShowText(v);
            }
        },
        data () {
            let that = this;
            return {
                innerSelected: [],
                show: false,
                dateActions: [
                    {
                        label: this.leftBtn,
                        onClick: function (e) {
                            this.handleClose(() => {
                                this.$emit('cancel', e);
                            });
                        }
                    },
                    {
                        label: this.type === 'date' ? this.rightBtn : '选择时间',
                        reflectDisabled: true,
                        onClick: function () {
                            if (that.type === 'date') {
                                this.handleChanges();
                            } else {
                                that.saveState();
                                that.currentPanel = 'time';
                                that.innerSelected = that.getInnerSelected();
                            }
                        }
                    }
                ],
                timeActions: [
                    {
                        label: '返回',
                        onClick: function (e) {
                            if (that.type !== 'time') {
                                that.currentPanel = 'date';
                                that.restoreState();
                            } else {
                                this.handleClose(() => {
                                    this.$emit('cancel', e);
                                });
                            }
                        }
                    },
                    {
                        label: this.rightBtn,
                        reflectDisabled: true,
                        onClick: function () {
                            this.handleChanges(that.type !== 'time' && that.restoreState);
                            that.type !== 'time' && (that.currentPanel = 'date');
                        }
                    }
                ],
                closing: false,
                showText: '',
                hasDisabled: false,
                dateGroups: this.initDateGroups(),
                timeGroups: this.initTimeGroups(),
                currentPanel: this.type === 'time' ? 'time' : 'date'
            };
        },
        methods: {
            saveState () {
                this.stateInSave = this.stateInSave || {};
                this.stateInSave[this.currentPanel] = this.innerSelected;
            },
            restoreState () {
                this.innerSelected = this.stateInSave[this.currentPanel];
            },
            handleVisible (visible = true) {
                if (this.disabled) return;
                const lastVis = this.show;
                this.show = !!visible;
                if (lastVis !== this.show) {
                    this.$emit('visible', {visible: this.show, instance: this});
                }
            },
            initDateGroups () {
                if (this.type === 'time') {
                    return;
                }
                const {maxYears, minYears} = this;

                const limitMaxYear = maxYears;
                const limitMinYears = minYears;

                const yearGroups = [];

                for (let i = limitMinYears; i <= limitMaxYear; i++) {
                    yearGroups.push({text: `${i}年`, value: i});
                }

                const monthGroups = this.createGroups(12, '月', 1);
                const dateGroups = this.createGroups(31, '日', 1);

                return [yearGroups, monthGroups, dateGroups];
            },
            initTimeGroups () {
                if (this.type !== 'datetime' && this.type !== 'time') {
                    return;
                }

                const hourGroups = this.createGroups(24, '时');
                const minuteGroups = this.createGroups(59, '分');
                const secondGroups = this.createGroups(59, '秒');

                return [hourGroups, minuteGroups, secondGroups];
            },
            createGroups (length, text, step = 0) {
                return Array.apply(null, {length}).map((v, idx) => ({
                    text: `${(idx + step) < 10 ? `0${idx + step}` : (idx + step)}${text}`,
                    value: idx + step
                }));
            },
            getShowText (selected) {
                selected = selected || this.selected;
                if (!selected) {
                    return '';
                }
                return moment.unix(selected).format(this.format ? this.format :
                    (this.type === 'date' ? 'YYYY-MM-DD' : (this.type === 'datetime' ? 'YYYY-MM-DD HH:mm:ss' : 'HH:mm:ss')));
            },
            getInnerSelected () {
                let _moment = moment();

                if (this.selected && this.$util.validate.numberic(this.selected)) {
                    _moment = moment.unix(this.selected);
                }

                const groups = this.currentPanel === 'date' ? this.dateGroups : this.timeGroups;

                const curYear = this.currentPanel === 'date' ? _moment.year() : _moment.hour();
                const curMonth = this.currentPanel === 'date' ? (_moment.month() + 1) : _moment.minute();
                const curDate = this.currentPanel === 'date' ? _moment.date() : _moment.second();
                return [
                    groups[0].findIndex(val => val.value === curYear),
                    groups[1].findIndex(val => val.value === curMonth),
                    groups[2].findIndex(val => val.value === curDate),
                ];
            },
            handleCancel () {
                this.show = false;
                this.$emit('visible', {visible: this.show, instance: this});
            },
            handleChange (e) {
                let dateObj = null;
                e.forEach((v, idx) => {
                    this.$set(this.innerSelected, idx, v);
                });
                dateObj = this.type === 'datetime' ? this.getIndex2RealDateTime(e) : (
                    this.type === 'date' ? this.getIndex2RealDate(e) : this.getIndex2RealTime(e)
                );

                const selected = moment(dateObj).unix();
                this.$emit('change', selected);
                this.showText = this.getShowText(selected);
                this.show = false;
                this.$emit('visible', {visible: this.show, instance: this});
            },
            handleGroupChange (item, i, groupIndex, selected) {
                if (this.currentPanel === 'date' && groupIndex <= 1) {
                    const dateObj = this.getIndex2RealDate(selected);
                    delete dateObj.day;

                    const allDays = moment(dateObj).daysInMonth();

                    this.$set(this.dateGroups, 2, Array.apply(null, {length: allDays}).map((v, idx) => ({
                        text: `${(idx + 1) < 10 ? `0${idx + 1}` : (idx + 1)}日`,
                        value: idx + 1
                    })));

                    if (!this.dateGroups[2][selected[2]]) {
                        this.$set(this.innerSelected, 2, allDays - 1);
                    }

                }
            },
            getIndex2RealTime (e) {
                let [hour, minute, second] = e;
                hour = this.timeGroups[0][hour].value;
                minute = this.timeGroups[1][minute].value;
                second = this.timeGroups[2][second].value;
                return {
                    hour, minute, second
                };
            },
            getIndex2RealDateTime (e) {
                return {
                    ...this.getIndex2RealDate(this.stateInSave.date),
                    ...this.getIndex2RealTime(e),
                };

            },
            getIndex2RealDate (e) {
                let [year, month, day] = e;
                year = this.dateGroups[0][year].value;
                month = this.dateGroups[1][month].value - 1;
                day = this.dateGroups[2][day].value;
                return {
                    year, month, day
                };
            }
        },
        computed: {},
        components: {NormalPicker, NormalInput},
        mounted () {
            this.showText = this.getShowText();
            this.innerSelected = this.getInnerSelected();
        },
        render () {
            const {
                show,
                border,
                placeholder,
                showText,
                dateGroups,
                innerSelected,
                dateActions,
                timeActions,
                currentPanel,
                timeGroups
            } = this;
            return (
                <div class="normal-datetime-picker">
                    <normal-input nativeOnClick={this.handleVisible}
                                  readonly={true} border={border}
                                  value={showText}
                                  placeholder={placeholder}/>
                    <NormalPicker visible={show}
                                  actions={currentPanel === 'date' ? dateActions : timeActions}
                                  onChange={this.handleChange}
                                  onGroupChange={this.handleGroupChange}
                                  onCancel={this.handleCancel}
                                  withBody={false}
                                  groups={currentPanel === 'date' ? dateGroups : timeGroups}
                                  selected={innerSelected}/>
                </div>
            );
        }
    };


</script>


<style lang="less" scoped>
    @import "../../assets/less/widgets-var";

    .normal-datetime-picker {

        &:after {
            font-family: cmsicon;
            content: "\e697";
            display: inline-block;
            border-color: @otherIptSelTipsDisbaledClr;
            position: absolute;
            color: @otherIptSelTipsDisbaledClr;
            .px2rem(height, 75);
            .px2rem(line-height, 80);
            .px2rem(width, 60);
            text-align: center;
            top: 50%;
            .px2rem(margin-top, -37.5);
            right: 0;
            background-color: #fff;
            z-index: 9;
        }
    }

    /deep/ .normal-input {
        .px2rem(font-size, 32);
    }

</style>
